import { Shuffle } from 'lucide-react'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import type { VersatileArtist } from '@/hooks/useDashboardChannel'

interface VersatileArtistSpotlightProps {
  artist: VersatileArtist
}

function initials(name: string) {
  return name
    .split(' ')
    .map((part) => part[0])
    .slice(0, 2)
    .join('')
    .toUpperCase()
}

export function VersatileArtistSpotlight({ artist }: VersatileArtistSpotlightProps) {
  return (
    <div className="flex h-full items-center gap-4 rounded-xl border border-border bg-card p-6">
      <Avatar className="size-14 shrink-0 ring-1 ring-border">
        <AvatarImage src={artist.image_url ?? undefined} alt="" />
        <AvatarFallback>{initials(artist.name)}</AvatarFallback>
      </Avatar>

      <div className="flex min-w-0 flex-1 flex-col gap-0.5">
        <span className="flex items-center gap-1.5 text-xs font-medium uppercase tracking-wide text-muted-foreground">
          <Shuffle className="size-3.5 text-primary" />
          Most versatile artist
        </span>
        <span className="truncate text-2xl font-semibold tracking-tight">{artist.name}</span>
        <span className="truncate text-sm text-muted-foreground">Spans {artist.genre_count} genres</span>
      </div>
    </div>
  )
}
